// form要素でエンターキーを叩いた時のsubmitを抑制します
export function setPreventEnter()
{
  if(process.env.NODE_ENV === "development")
    console.log("[INFO] set prevent enter")
  const inputs = Array.from(document.querySelectorAll("input:not([data-enter-confirmable])"));
  inputs.map((e) => e.onkeydown = preventEnterSubmit);
}

function preventEnterSubmit(ev){
  if(ev.key === "Enter")
    ev.preventDefault();
}
